(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
	 * @version     1.0.0
     * @param       object $block     The block jQuery element.
     * @param       object attributes The block attributes (only available when editing).
     * @return      void
     */

	var initializeBlock = function( $block ) {
        //Init slick slider carousel
        let block_id    =  $block.attr('data-id'),
				slides_id   = `.js-carousel-gallery-${block_id}`;

		var swiperCarousel = new Swiper(slides_id, {
			freeMode: true,
			centeredSlides: true,
			breakpoints: {
				500: {
					centeredSlides: false,
				}
			},
			slidesPerView: 'auto',
			autoheight: true,
			autoplay: {
				delay: 5000,
			},
			spaceBetween: 24,
			grabCursor: true,
			navigation: {
				nextEl: '.c-season-carousel__arrow--next',
				prevEl: '.c-season-carousel__arrow--prev',
			},
			a11y: {
				prevSlideMessage: 'Imagen anterior',
				nextSlideMessage: 'Siguiente imagen',
			},
			pagination: {
				el: '.c-season-carousel__pagination',
				dynamicBullets: true,
				clickable: true,
			  },
		});
		
    };

	// Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.c-season-carousel').each(function(){
			initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=season-carousel', initializeBlock );
    }

})(jQuery);